<template>
    <edit></edit>
</template>

<script>
    import edit from './limit_time_discount_edit.vue'

    export default {
        name: 'limit_time_discount_add',

        components: {
            edit
        }
    }
</script>